import React, { useState } from 'react';
import dataManager from '../utils/dataManager';
import ImageWithFallback from './ImageWithFallback';
import './TeacherList.css';

const TeacherList = () => {
  const teachers = dataManager.getTeachersSync() || [];

  return (
    <div className="teacher-list">
      <div className="teacher-list-header">
        <h2>🧘‍♀️ 导师团队</h2>
        <p>认识我们经验丰富的阿斯汤加瑜伽导师</p>
      </div>

      <div className="teachers-grid">
        {teachers.map(teacher => (
          <div key={teacher.id} className="teacher-card">
            <div className="teacher-photo">
              <ImageWithFallback
                src={`/static/yoga/${teacher.photo}`}
                alt={teacher.name}
                fallbackSrc="/static/yoga/yujiang.jpg"
                showFilenameOnError={true}
              />
            </div>

            <div className="teacher-info">
              <div className="teacher-header">
                <h3>{teacher.name}</h3>
                <div className="teacher-meta">
                  <span className="experience">📅 {teacher.experience}年经验</span>
                  <span className="location">📍 {teacher.location}</span>
                </div>
              </div>

              <div className="teacher-bio">
                <p className="bio-summary">{teacher.bio}</p>
                <p className="detailed-bio">{teacher.detailedBio}</p>
              </div>

              <div className="specialties">
                <h4>🎯 专业领域</h4>
                <div className="specialty-tags">
                  {teacher.specialties.split('、').map((specialty, index) => (
                    <span key={index} className="specialty-tag">
                      {specialty}
                    </span>
                  ))}
                </div>
              </div>

              <div className="certification">
                <h4>🎓 认证资质</h4>
                <p>{teacher.certification}</p>
              </div>

              <div className="teaching-philosophy">
                <h4>💭 教学理念</h4>
                <blockquote>"{teacher.teachingPhilosophy}"</blockquote>
              </div>

              <div className="achievements">
                <h4>🏆 主要成就</h4>
                <ul>
                  {teacher.achievements.map((achievement, index) => (
                    <li key={index}>{achievement}</li>
                  ))}
                </ul>
              </div>


            </div>
          </div>
        ))}
      </div>


    </div>
  );
};

export default TeacherList;
